/**
 * Promo Code Manager
 * Handles AJAX apply of discount codes + section re-rendering.
 * Loaded by both cart-drawer and main-cart templates.
 */
(function () {
  'use strict';

  /* Prevent double-init when both drawer and cart page include this file */
  if (window.__promoCodeInit) return;
  window.__promoCodeInit = true;

  /* ── Helpers ─────────────────────────────────────────────────── */

  /**
   * Parse a section HTML string and return the innerHTML of a selector.
   */
  function getInnerHTML(sectionHTML, selector) {
    var tmpl = document.createElement('template');
    tmpl.innerHTML = sectionHTML;
    var el = tmpl.content.querySelector(selector);
    return el ? el.innerHTML : null;
  }

  /**
   * Build the list of Shopify section IDs we need to re-fetch.
   */
  function getSectionIds() {
    var ids = ['cart-icon-bubble', 'free-shipping-notice'];

    /* Cart drawer section id */
    var drawer = document.getElementById('cart-drawer');
    if (drawer) {
      var sec = drawer.closest('.shopify-section');
      if (sec) ids.push(sec.id.replace('shopify-section-', ''));
    }

    /* Cart page section id */
    var summary = document.getElementById('cart-summary');
    if (summary && summary.dataset.section) ids.push(summary.dataset.section);

    /* Cart-items section id (cart page only) */
    var cartItems = document.querySelector('cart-items');
    if (cartItems && cartItems.dataset.section) ids.push(cartItems.dataset.section);

    /* Deduplicate */
    return ids.filter(function (v, i, a) { return a.indexOf(v) === i; });
  }

  /**
   * Re-render all relevant cart sections without a full page reload.
   */
  function refreshSections() {
    var ids = getSectionIds();

    return fetch(window.location.pathname + '?sections=' + ids.join(','))
      .then(function (r) { return r.json(); })
      .then(function (data) {

        /* ── Cart drawer summary ── */
        var drawer = document.getElementById('cart-drawer');
        if (drawer) {
          var drawerSecEl = drawer.closest('.shopify-section');
          var drawerSecId = drawerSecEl ? drawerSecEl.id.replace('shopify-section-', '') : null;
          if (drawerSecId && data[drawerSecId]) {
            var drawerSummary = drawer.querySelector('.cart-drawer__summary');
            if (drawerSummary) {
              var html = getInnerHTML(data[drawerSecId], '.cart-drawer__summary');
              if (html !== null) drawerSummary.innerHTML = html;
            }
            var drawerItems = drawer.querySelector('cart-items');
            if (drawerItems) {
              var itemsHtml = getInnerHTML(data[drawerSecId], 'cart-items');
              if (itemsHtml !== null) {
                drawerItems.innerHTML = itemsHtml;
                drawerItems.dataset.empty = !!drawerItems.querySelector('.js-cart-empty');
              }
            }
          }
        }

        /* ── Cart page summary ── */
        var summaryEl = document.getElementById('cart-summary');
        if (summaryEl) {
          var pageSecId = summaryEl.dataset.section;
          if (pageSecId && data[pageSecId]) {
            var newHtml = getInnerHTML(data[pageSecId], '#cart-summary');
            if (newHtml !== null) summaryEl.innerHTML = newHtml;
          }
        }

        /* ── Cart page items ── */
        var cartItemsEl = document.querySelector('cart-items');
        if (cartItemsEl && !drawer) {
          var ciSecId = cartItemsEl.dataset.section;
          if (ciSecId && data[ciSecId]) {
            var ciHtml = getInnerHTML(data[ciSecId], 'cart-items');
            if (ciHtml !== null) {
              cartItemsEl.innerHTML = ciHtml;
              cartItemsEl.dataset.empty = !!cartItemsEl.querySelector('.js-cart-empty');
            }
          }
        }

        /* ── Cart icon bubble (header count) ── */
        if (data['cart-icon-bubble']) {
          var bubble = document.getElementById('cart-icon-bubble');
          if (bubble) {
            var bHtml = getInnerHTML(data['cart-icon-bubble'], '.shopify-section');
            if (bHtml !== null) bubble.innerHTML = bHtml;
          }
          var drawerCount = document.getElementById('cart-drawer__count');
          if (drawerCount) {
            var countHtml = getInnerHTML(data['cart-icon-bubble'], '.header__cart-count-number');
            if (countHtml !== null) drawerCount.innerHTML = '(' + countHtml + ')';
          }
        }

        /* ── Free shipping notice ── */
        if (data['free-shipping-notice']) {
          var fsn = document.querySelector('.free-shipping-notice');
          if (fsn) {
            var fsnHtml = getInnerHTML(data['free-shipping-notice'], '.free-shipping-notice');
            if (fsnHtml !== null) fsn.innerHTML = fsnHtml;
          }
        }

        /* Re-init lazy images if available */
        if (window.initLazyImages) window.initLazyImages();
      });
  }

  /* ── Apply ──────────────────────────────────────────────────── */

  function applyDiscount(code) {
    return fetch('/discount/' + encodeURIComponent(code), {
      method: 'GET',
      redirect: 'follow',
      credentials: 'same-origin'
    }).then(function () {
      return refreshSections();
    });
  }

  /* ── Event delegation ───────────────────────────────────────── */

  document.addEventListener('click', function (e) {

    /* Apply promo code */
    var applyBtn = e.target.closest('.js-apply-promo');
    if (applyBtn) {
      var wrap = applyBtn.closest('.flex');
      var input = wrap ? wrap.querySelector('input[name="discount"]') : null;
      if (input && input.value.trim()) {
        var code = input.value.trim();
        applyBtn.disabled = true;
        applyBtn.textContent = '…';
        applyDiscount(code)
          .then(function () {
            input.value = '';
            var cb = input.parentElement.querySelector('.js-promo-clear');
            if (cb) cb.style.display = 'none';
          })
          .catch(function () {
            /* Fallback: full redirect */
            window.location.href = '/discount/' + encodeURIComponent(code) +
              '?redirect=' + encodeURIComponent(window.location.pathname);
          })
          .finally(function () {
            applyBtn.disabled = false;
            applyBtn.textContent = 'Apply';
          });
      }
      return;
    }

    /* Clear promo input field */
    var clearBtn = e.target.closest('.js-promo-clear');
    if (clearBtn) {
      var inp = clearBtn.parentElement.querySelector('.js-promo-input');
      if (inp) {
        inp.value = '';
        inp.focus();
        clearBtn.style.display = 'none';
      }
      return;
    }
  });

  /* Show / hide clear button on input */
  document.addEventListener('input', function (e) {
    if (!e.target.classList.contains('js-promo-input')) return;
    var cb = e.target.parentElement.querySelector('.js-promo-clear');
    if (cb) cb.style.display = e.target.value.length > 0 ? 'block' : 'none';
  });

  /* Allow Enter key to submit promo code */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    if (!e.target.classList.contains('js-promo-input')) return;
    e.preventDefault();
    var wrap = e.target.closest('.flex');
    var btn = wrap ? wrap.querySelector('.js-apply-promo') : null;
    if (btn) btn.click();
  });
})();
